// @flow
import type { Setting } from './../types';
import CommonApi from './../commonApi';

const setting = new CommonApi<Setting>('settings', 'Настройки системы');

export default {
  ...setting,
};
